import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Dialog from 'Components/UI/Dialog';
import closeModal from 'Helpers/ModalHelper';
import useMobileLayout from 'Hooks/useMobileLayout';

import DialogContainer from './DialogContainer';

const styles = () => ({
  paper: {
    width: '100%',
  },
});

const FinancialWellnessScoreDialog = ({
  classes,
  ...rest
}) => {
  const isMobile = useMobileLayout();

  return (
    <Dialog
      classes={classes}
      fullScreen={isMobile}
      onClose={closeModal}
      open
      variant="modern"
      maxWidth="md"
    >
      <DialogContainer {...rest} />
    </Dialog>
  );
};

FinancialWellnessScoreDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  financialWellnessScoreLink: PropTypes.string.isRequired,
  componentName: PropTypes.string.isRequired,
};

export default withStyles(styles)(FinancialWellnessScoreDialog);
